import { type GoToShopButtonResources } from "./GoToShopButton.Resources";

export const GoToShopButtonResourcesEn: typeof GoToShopButtonResources = {
    cashbackButtonText: "Go to shop",
};
